import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromBatteryTestStatus from './reducers/battery-test-status.reducer';
import { BatteryTestStatusEffects } from './effects/battery-test-status.effects';
import * as fromBatteryTestScheduler from './reducers/battery-test-scheduler.reducer';
import { BatteryTestSchedulerEffects } from './effects/battery-test-scheduler.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([BatteryTestStatusEffects, BatteryTestSchedulerEffects]),
    StoreModule.forFeature('batteryTestStatus', fromBatteryTestStatus.reducer),
    StoreModule.forFeature('batteryTestScheduler', fromBatteryTestScheduler.reducer),
    StoreModule.forFeature('batteryTestSchedulerDetail', fromBatteryTestScheduler.batteryTestSchedulerDetailReducer),
    StoreModule.forFeature('batteryTestSchedulerReducer', fromBatteryTestScheduler.batteryTestSchedulerResultReducer),
  ]
})
export class BatteryTestModule { }
